import styled from '@emotion/styled';

export const NameCell = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  minWidth: 0,
}));
